import React, { useState, useEffect, useRef } from "react";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Button, Select, MenuItem, FormControl, InputLabel, Grid, Card, CardContent, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CloudUpload } from "@material-ui/icons";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const useStyles = makeStyles(theme => ({
  mainPaper: { flex: 1, padding: theme.spacing(1), overflowY: "scroll" },
  card: { marginBottom: theme.spacing(2) },
}));

function fueraDeHorario() {
  const hora = new Date().toLocaleString("es-AR", { timeZone: "America/Argentina/Buenos_Aires", hour: "numeric", hour12: false });
  const h = parseInt(hora);
  return h < 8 || h >= 20;
}

const statusColor = { pendiente: "default", enviando: "primary", enviado: "primary", error: "secondary", rechazado: "secondary" };

const EnviosQueue = () => {
  const classes = useStyles();
  const [queue, setQueue] = useState([]);
  const [log, setLog] = useState([]);
  const [stats, setStats] = useState([]);
  const [empresaFiltro, setEmpresaFiltro] = useState("");
  const [statusFiltro, setStatusFiltro] = useState("");
  const [tab, setTab] = useState("cola");
  const [importDialog, setImportDialog] = useState(false);
  const [limiteDialog, setLimiteDialog] = useState(false);
  const [limiteEmpresa, setLimiteEmpresa] = useState(null);
  const [limiteValor, setLimiteValor] = useState("");
  const [empresaImport, setEmpresaImport] = useState("");
  const [empresaInfo, setEmpresaInfo] = useState(null);
  const [preview, setPreview] = useState([]);
  const [cargando, setCargando] = useState(false);
  const fileRef = useRef();

  const handleEditLimite = (empresa) => {
    setLimiteEmpresa(empresa);
    setLimiteValor(empresa.limite_diario);
    setLimiteDialog(true);
  };

  const handleSaveLimite = async () => {
    try {
      await api.put("/envios/limite", { empresa_id: limiteEmpresa.id, limite_diario: parseInt(limiteValor) });
      toast.success("Limite actualizado para manana");
      setLimiteDialog(false);
      cargarDatos();
    } catch (err) {
      toastError(err);
    }
  };

  const cargarDatos = async () => {
    try {
      const params = {};
      if (empresaFiltro) params.empresa_id = empresaFiltro;
      if (statusFiltro) params.status = statusFiltro;
      if (tab === "cola") {
        const { data } = await api.get("/envios/queue", { params });
        setQueue(data);
      } else {
        const { data } = await api.get("/envios/log", { params });
        setLog(data);
      }
      const { data: s } = await api.get("/envios/stats");
      setStats(s);
    } catch (err) { toastError(err); }
  };

  useEffect(() => { cargarDatos(); }, [tab, empresaFiltro, statusFiltro]);

  const handleEmpresaImport = async (id) => {
    setEmpresaImport(id);
    setPreview([]);
    if (!id) return;
    const emp = stats.find(s => s.id == id);
    setEmpresaInfo(emp || null);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const wb = XLSX.read(ev.target.result, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws);
      setPreview(data.slice(0, 5));
    };
    reader.readAsBinaryString(file);
  };

  const handleImport = async () => {
    const file = fileRef.current.files[0];
    if (!file || !empresaImport) return;
    setCargando(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const wb = XLSX.read(ev.target.result, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(ws);
        const emp = stats.find(s => s.id == empresaImport);
        const msgModelo = emp?.mensaje_modelo || "Hola {nombre}!";
        
        let ok = 0, skip = 0, error = 0;
        for (const row of data) {
          const nombre = row.nombre || row.nome || row.NOMBRE || "";
          const numero = String(row.numero || row.NUMERO || "").replace(/\D/g, "");
          if (!numero) { error++; continue; }
          const nombreCorto = nombre.split(" ")[0] || "Cliente";
          const mensaje = msgModelo.replace("{nombre}", nombreCorto);
          try {
            const { data: resp } = await api.post("/envios/queue", {
              empresa_id: parseInt(empresaImport),
              numero, mensaje, tipo: "excel"
            });
            if (resp.ok) ok++; else skip++;
          } catch { error++; }
        }
        toast.success(`Importado: ${ok} OK | ${skip} duplicados/baja | ${error} errores`);
        setImportDialog(false);
        setCargando(false);
        cargarDatos();
      };
      reader.readAsBinaryString(file);
    } catch (err) { toastError(err); setCargando(false); }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>Cola de Envios</Title>
        <MainHeaderButtonsWrapper>
          <Button variant="contained" color="secondary" startIcon={<CloudUpload />} onClick={() => setImportDialog(true)}>
            Importar Excel
          </Button>
          <Button variant={tab === "cola" ? "contained" : "outlined"} color="primary" onClick={() => setTab("cola")} style={{marginLeft:8}}>Cola</Button>
          <Button variant={tab === "log" ? "contained" : "outlined"} color="primary" onClick={() => setTab("log")} style={{marginLeft:8}}>Historial</Button>
          <Button variant="outlined" onClick={cargarDatos} style={{marginLeft:8}}>Actualizar</Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      <Grid container spacing={2} style={{marginBottom:16}}>
        {stats.map(s => (
          <Grid item xs={12} sm={4} key={s.id}>
            <Card className={classes.card}>
              <CardContent>
                <Typography variant="h6">{s.nombre}</Typography>
                {s.descripcion && <Typography variant="caption" color="textSecondary">{s.descripcion}</Typography>}
                <Typography>Pendientes: <strong>{s.pendientes}</strong> | Enviados hoy: <strong>{s.enviados_hoy}</strong> | Bajas: <strong>{s.bajas}</strong></Typography>
                <Typography style={{display:"flex",alignItems:"center",gap:8,marginTop:4}}>
                  Limite: <strong>{s.limite_diario}/dia</strong>
                  <Button size="small" variant="contained" color="primary" onClick={() => handleEditLimite(s)} title="Editar limite diario" style={{minWidth:80,padding:"2px 8px",marginLeft:8}}>
                    ✏️ Editar
                  </Button>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} style={{marginBottom:16}}>
        <Grid item xs={6} sm={3}>
          <FormControl fullWidth size="small">
            <InputLabel>Empresa</InputLabel>
            <Select value={empresaFiltro} onChange={e => setEmpresaFiltro(e.target.value)}>
              <MenuItem value="">Todas</MenuItem>
              {stats.map(s => <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} sm={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Estado</InputLabel>
              <Select value={statusFiltro} onChange={e => setStatusFiltro(e.target.value)}>
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="pendiente">Pendiente</MenuItem>
                <MenuItem value="enviado">Enviado</MenuItem>
                <MenuItem value="error">Error</MenuItem>
                <MenuItem value="rechazado">Rechazado</MenuItem>
              </Select>
            </FormControl>
          </Grid>
      </Grid>

      <Paper className={classes.mainPaper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Empresa</TableCell>
              <TableCell>Numero</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Estado</TableCell>
              <TableCell>Fecha</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(tab === "cola" ? queue : log).map(row => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.empresa_nombre || row.empresa_id}</TableCell>
                <TableCell>{row.numero}</TableCell>
                <TableCell>{row.tipo}</TableCell>
                <TableCell><Chip size="small" label={row.status} color={statusColor[row.status] || "default"} /></TableCell>
                <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("es-AR") : ""}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>

      <Dialog open={limiteDialog} onClose={() => setLimiteDialog(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Editar Limite Diario — {limiteEmpresa?.nombre}</DialogTitle>
        <DialogContent>
          <Typography variant="caption" color="textSecondary" style={{display:"block",marginBottom:16}}>
            El nuevo limite aplica desde manana. Durante el horario 8-20hs el boton esta bloqueado.
          </Typography>
          <TextField fullWidth label="Mensajes por dia" type="number" value={limiteValor}
            onChange={e => setLimiteValor(e.target.value)} inputProps={{min:0, max:500}} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLimiteDialog(false)}>Cancelar</Button>
          <Button onClick={handleSaveLimite} color="primary" variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Importar Excel */}
      <Dialog open={importDialog} onClose={() => setImportDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Importar Excel</DialogTitle>
        <DialogContent>
          <FormControl fullWidth style={{marginBottom:16}}>
            <InputLabel>Empresa</InputLabel>
            <Select value={empresaImport} onChange={e => handleEmpresaImport(e.target.value)}>
              <MenuItem value="">Seleccionar empresa</MenuItem>
              {stats.map(s => <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>)}
            </Select>
          </FormControl>

          {empresaImport && (
            <>
              <Typography variant="caption" color="textSecondary" style={{display:"block", marginBottom:8}}>
                El Excel debe tener columnas: <strong>nombre</strong> y <strong>numero</strong>
              </Typography>
              <input type="file" accept=".xlsx,.xls" ref={fileRef} onChange={handleFileChange} style={{marginBottom:16}} />
              {preview.length > 0 && (
                <Paper variant="outlined" style={{padding:8}}>
                  <Typography variant="caption"><strong>Preview (5 primeros):</strong></Typography>
                  {preview.map((r,i) => (
                    <Typography key={i} variant="caption" style={{display:"block"}}>
                      {r.nombre || r.nome} — {r.numero}
                    </Typography>
                  ))}
                </Paper>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setImportDialog(false)}>Cancelar</Button>
          <Button onClick={handleImport} color="primary" variant="contained" disabled={!empresaImport || cargando}>
            {cargando ? <CircularProgress size={20} /> : "Importar"}
          </Button>
        </DialogActions>
      </Dialog>
    </MainContainer>
  );
};

export default EnviosQueue;
